Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var coreComponentsMq = require('../mq');
var coreComponentsShared = require('../shared');
var Component = require('./Component.js');
var utils = require('./utils.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var SystemMessageResponsiveComponent = function (_a) {
    var _b = _a.breakpoint, breakpoint = _b === void 0 ? coreComponentsShared.getComponentBreakpoint() : _b, defaultMatchMediaValue = _a.defaultMatchMediaValue, children = _a.children, restProps = tslib.__rest(_a, ["breakpoint", "defaultMatchMediaValue", "children"]);
    var query = "(min-width: ".concat(breakpoint, "px)");
    var getDefaultValue = function () { return (coreComponentsShared.isClient() ? window.matchMedia(query).matches : false); };
    var isDesktop = coreComponentsMq.useMatchMedia(query, defaultMatchMediaValue !== null && defaultMatchMediaValue !== void 0 ? defaultMatchMediaValue : getDefaultValue)[0];
    return (React__default.default.createElement(Component.SystemMessage, tslib.__assign({}, restProps, { view: isDesktop ? 'desktop' : 'mobile' }), children));
};
var SystemMessageResponsive = utils.createCompound(SystemMessageResponsiveComponent);

exports.SystemMessageResponsive = SystemMessageResponsive;
